import { create } from 'zustand'

export type PaywallReason = 'insufficient-credits' | 'tier-required'

interface PaywallState {
  isOpen: boolean
  reason: PaywallReason | null
  message: string | null
  requiredAmount: number | null
  open: (input: {
    reason: PaywallReason
    message?: string
    requiredAmount?: number
  }) => void
  close: () => void
}

export const usePaywallStore = create<PaywallState>()((set) => ({
  isOpen: false,
  reason: null,
  message: null,
  requiredAmount: null,
  open: ({ reason, message, requiredAmount }) =>
    set({
      isOpen: true,
      reason,
      message: message ?? null,
      requiredAmount: requiredAmount ?? null,
    }),
  close: () =>
    set({
      isOpen: false,
      reason: null,
      message: null,
      requiredAmount: null,
    }),
}))
